import styled from 'styled-components';

import { Icon } from '@creditornot/alchemy-react';
import * as icons from '@creditornot/alchemy-react/icons';
import { color } from '@creditornot/cb-ingredients/design-tokens';
import { Typography as T } from 'common/components/cookbook/Typography/Typography';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

const Root = styled.div`
  display: flex;
  align-items: center;
`;

const receivingStatusColors = {
  incomplete: color.textSubdued,
  full: color.textPositive,
  overflow: color.textWarning,
};

const IconContainer = styled.div`
  margin-right: 8px;
`;

type Props = {
  receivedQuantity: number;
  orderedQuantity: number;
};

const getFillColor = (receivedQuantity: number, orderedQuantity: number): string => {
  if (receivedQuantity < orderedQuantity) {
    return receivingStatusColors.incomplete;
  }
  if (receivedQuantity === orderedQuantity) {
    return receivingStatusColors.full;
  }
  return receivingStatusColors.overflow;
};

export const ProgressIndicator = ({ receivedQuantity, orderedQuantity }: Props) => {
  const formatMessage = useFormatMessage();

  return (
    <Root>
      <IconContainer>
        <Icon
          source={icons.plusCircleFilled}
          size="small"
          height={20}
          width={20}
          fill={getFillColor(receivedQuantity, orderedQuantity)}
        />
      </IconContainer>
      <T.body>
        {receivedQuantity}
        {' / '}
        {orderedQuantity}{' '}
        {formatMessage('common.unit_plural', {
          unitCount: orderedQuantity,
        })}
      </T.body>
    </Root>
  );
};
